import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { Button, ButtonGroup, Stack, Grid, Pagination, Typography, IconButton, Container, Card, TableContainer, Table, TableBody } from "@mui/material";
import { alert } from "src/services/alert";
import axios from "axios";
import { BASE_URL, IMG_BASE_URL } from "src/config/constants";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import ListHead from "src/components/common/ListHead";
import MyPagination from "src/components/common/MyPagination";

export const Images = ({ title }) => {
  const ref = useRef();
  const [pictures, setPictures] = useState([]);
  const [selected, setSelected] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 24,
    search: "",
  });

  useEffect(() => {
    getImages();
  }, [filter]);

  function getImages() {
    axios
    .post("/picture/all", filter)
    .then((res) => {
      const { code, msg, data, total } = res.data;
      if (code === 1) {
        setPictures(data);
        setTotal(total);
      } else {
        alert(msg);
      }
    })
    .catch((err) => {
      console.log("err", err);
    });
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  function handleImgClick(item) {
    const imgs = [...selected];
    const idx = imgs.findIndex(a => a.id === item.id);
    if (idx === -1) {
      if (imgs.length < 1) {
        imgs.push(item);
      } else {
        imgs[0] = item;
      }
    } else {
      imgs.splice(idx, 1);
    }

    setSelected(imgs);
  }

  function handleUpload(e) {
    if (!e.target.files[0]) return;
    // console.log(e.target.files)

    const formData = new FormData();
    for (let i = 0; i < e.target.files.length; i++) {
      formData.append("images", e.target.files[i]);
    }

    axios
      .post("/upload/bulk", formData)
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          ref.current.value = null;
          setPictures([...data, ...pictures].slice(0, filter.size));
          setSelected([]); // 重置
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function handleDelPictures() {
    if (!selected.length) return;

    axios
      .post("/picture/del", { ids: selected.map(s => s.id) })
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          // setPictures(data);
          getImages();
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("删除图片", err);
      });
  }

  function renderImages() {
    // console.log(selected)
    return pictures.map((item, index) => {
      const { id, path } = item;
      const active = selected.findIndex(a => a.id === id) > -1;

      return (
        <Grid item key={index}>
          <Stack
            key={id}
            sx={{
              cursor: "pointer",
              border: active ? "2px solid #5fb878" : "2px solid transparent",
            }}
            onClick={() => handleImgClick(item)}
          >
            <img
              src={`${IMG_BASE_URL}${path}`}
              alt={path}
              loading="lazy"
              style={{
                width: 100,
                height: 100,
                objectFit: "contain",
              }}
            />
            {/* <Typography noWrap>{path}</Typography> */}
          </Stack>
        </Grid>
      );
    });
  }

  return (
    <Page title="图片列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            图片列表
          </Typography>

          {/* <Button
            variant="contained"
            startIcon={<Icon icon={plusFill} />}
          >
            添加图片
          </Button> */}
          <ButtonGroup>
            <Button sx={{ position: "relative", borderRadius: 0 }} component="label" htmlFor="contained-button-file">
              上传图片{" "}
              <input
                ref={ref}
                accept="image/*"
                id="contained-button-file"
                multiple={true}
                type="file"
                onChange={handleUpload}
                style={{
                  position: "absolute",
                  visibility: "hidden",
                }}
              />
            </Button>

            <Button disabled={selected.length === 0} onClick={handleDelPictures}>
              删除图片
            </Button>
          </ButtonGroup>
        </Stack>

        <Card>
          {/* <UserListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
          /> */}

          {/* <Scrollbar>
            {renderImages()}
          </Scrollbar> */}

          <Grid container spacing={1} columns={8} padding={4}>
            {renderImages()}
          </Grid>


          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>
    </Page>
  )

}

export default Images;